angular.module('rentalListingModule').component('rentalListingSubmit', {
	templateUrl: 'rentalListingSubmit/rentalListingSubmit.html',
	bindings: {
		form: '<',
		user: '<',
		fbUser: '<',
		fbError: '<',
		listing: '<',
		isLoggedIn: '<',
		isMobile: '<',
		errorMessages: '<',
		termsOfUseUrl: '<',
		privacyPolicyUrl: '<',
		forgotLinkUrl: '<',
		activeFormType: '<',
		missingImageSrc: '<',
		onFieldChange: '&',
		onUpdateActiveForm: '&',
		onFbLogin: '&',
		onValidateEmail: '&'
	},
	controller: ['$http', function($http) {
		var ctrl = this;
		// since i am reusing the form, i have to set the form to its pristine state.
		this.form.$setPristine();
		this.fieldSteps = {
			building: 1,
			unit: 1,
			beds: 1,
			baths: 1,
			price: 1,
			sqft: 1,
			agent: 1,
			option: 1,
			upload: 2,
			form: 3,
			login: 3,
			limit: 3
		}

		this.displayForm = function(form) {
			this.onUpdateActiveForm({form: form});
		};

		this.fieldChange = function(key) {
			this.onFieldChange({key: key});
		};

		this.validateEmail = function(email, form) {
			this.onValidateEmail({email: email, form: form});
		};
	}]
});
